import {
  ClientPolicyCategory,
  ClientPolicyUnit,
  type GetClientPolicyResponseAPI,
  LeaveTypeEnum,
  PayTypeEnum,
} from '@omnipresentgroup/types';

export const GET_CLIENT_POLICY_RESPONSE: GetClientPolicyResponseAPI = [
  {
    type: LeaveTypeEnum.SICK,
    category: ClientPolicyCategory.STATUTORY,
    country: {
      code: 'ES',
      name: 'Spain',
    },
    description: 'Days 1-3: 0% Pay; Days 4-5: 60% Pay',
    extra_description: '',
    periods: [
      {
        start: 1,
        end: 3,
        unit: ClientPolicyUnit.DAY,
        pay_details: {
          pay_type: PayTypeEnum.PERCENTAGE,
          percentage_value: 0,
        },
      },
      {
        start: 4,
        end: 5,
        unit: ClientPolicyUnit.DAY,
        pay_details: {
          pay_type: PayTypeEnum.PERCENTAGE,
          percentage_value: 60,
        },
      },
    ],
    custom_minimum: {
      start: 4,
      end: 5,
      unit: ClientPolicyUnit.DAY,
      pay_details: {
        pay_type: PayTypeEnum.PERCENTAGE,
        percentage_value: 100,
      },
    },
  },
  {
    type: LeaveTypeEnum.SICK,
    category: ClientPolicyCategory.CUSTOM,
    country: {
      code: 'DE',
      name: 'Germany',
    },
    description: 'Weeks 1-10: 100% Pay',
    extra_description: '',
    periods: [
      {
        start: 1,
        end: 10,
        unit: ClientPolicyUnit.WEEK,
        pay_details: {
          pay_type: PayTypeEnum.PERCENTAGE,
          percentage_value: 100,
        },
      },
    ],
    custom_minimum: {
      start: 1,
      end: 9,
      unit: ClientPolicyUnit.WEEK,
      pay_details: {
        pay_type: PayTypeEnum.PERCENTAGE,
        percentage_value: 100,
      },
    },
    client_policy_explanations: [
      {
        title: 'Sick leave in Germany',
        content: ['The law provides up to 6 weeks to pay per illness'],
      },
      {
        title: 'What you need to know',
        content: [
          [
            'The obligation to provide sick leave only arises after the first month of employment has been completed',
            'Employees must notify their employer immediately if they are sick',
          ],
        ],
      },
      {
        title: 'Eligibility',
        content: [
          'Under the Continued Remuneration Act, employees who have been employed for 4 weeks are eligible for 6 weeks of statutory sick pay, unless their actions significantly contributed to their illness',
          'If the employee has a recurring illness, entitlement renews on sooner of:',
          [
            '6 months since end of last sick leave',
            '1 year since start of last sick leave',
          ],
          'If the illness is caused by a different underlying condition, the six-weeks period restarts automatically',
        ],
      },
    ],
  },
  {
    type: LeaveTypeEnum.SICK,
    category: ClientPolicyCategory.STATUTORY,
    country: {
      code: 'PT',
      name: 'Portugal',
    },
    description: 'Days 1-3: 0% Pay',
    extra_description: '',
    periods: [
      {
        start: 1,
        end: 3,
        unit: ClientPolicyUnit.DAY,
        pay_details: {
          pay_type: PayTypeEnum.PERCENTAGE,
          percentage_value: 0,
        },
      },
    ],
    custom_minimum: null,
  },
  {
    type: LeaveTypeEnum.SICK,
    category: ClientPolicyCategory.STATUTORY,
    country: {
      code: 'IT',
      name: 'Italy',
    },
    description: '',
    extra_description: '',
    notice: 'Dependent on Collective Bargaining Agreement',
    periods: [],
    custom_minimum: null,
  },
  {
    type: LeaveTypeEnum.SICK,
    category: ClientPolicyCategory.STATUTORY,
    country: {
      code: 'SE',
      name: 'Sweden',
    },
    description: 'Days 1-14: 80% Pay',
    extra_description: '',
    periods: [
      {
        start: 1,
        end: 14,
        unit: ClientPolicyUnit.DAY,
        pay_details: {
          pay_type: PayTypeEnum.PERCENTAGE,
          percentage_value: 80,
        },
      },
    ],
    custom_minimum: null,
  },
  {
    type: LeaveTypeEnum.SICK,
    category: ClientPolicyCategory.STATUTORY,
    country: {
      code: 'UK',
      name: 'United Kingdom',
    },
    description: 'Weeks 1-28: 116.75 GBP per week',
    extra_description: '',
    periods: [
      {
        start: 1,
        end: 28,
        unit: ClientPolicyUnit.WEEK,
        pay_details: {
          pay_type: PayTypeEnum.FIXED,
          fixed_value: {
            amount: 116.75,
            currency: 'GBP',
          },
        },
      },
    ],
    custom_minimum: {
      start: 1,
      end: 10,
      unit: ClientPolicyUnit.WEEK,
      pay_details: {
        pay_type: PayTypeEnum.FIXED,
        fixed_value: {
          amount: 116.75,
          currency: 'GBP',
        },
      },
    },
  },
  {
    type: LeaveTypeEnum.SICK,
    category: ClientPolicyCategory.CUSTOM,
    country: {
      code: 'NL',
      name: 'Netherlands',
    },
    description: 'Weeks 1-104: 70% Pay',
    extra_description: '',
    periods: [
      {
        start: 1,
        end: 104,
        unit: ClientPolicyUnit.WEEK,
        pay_details: {
          pay_type: PayTypeEnum.PERCENTAGE,
          percentage_value: 70,
        },
      },
    ],
    custom_minimum: null,
  },
];

export const GET_CLIENT_POLICY_DEFAULTS_RESPONSE: GetClientPolicyResponseAPI =
  GET_CLIENT_POLICY_RESPONSE.map((policy) => ({
    ...policy,
    category: ClientPolicyCategory.STATUTORY,
  }));
